import { makeActionCreatorSurvey } from '../../../../shared/utils/makeActionCreator';
import { RELOAD_STATE, ReloadStateAction, SET_SURVEY_ERROR, SetSurveyErrorAction } from './types';

export const setSurveyError = makeActionCreatorSurvey(SET_SURVEY_ERROR, 'error') as (
	error: string
) => SetSurveyErrorAction;

export const reloadSurveyBuilderState = makeActionCreatorSurvey(RELOAD_STATE) as () => ReloadStateAction;
